import type { TooltipRenderProps } from 'react-joyride';

import styles from './styles';
import Box from '@material-ui/core/Box';

import { CloseButton } from '@cobliteam/base-components';

import { Button } from '@cobliteam/ui/components';
import cn from '@cobliteam/ui/utils/cn';

export default function CardTour({
  index,
  size,
  step,
  backProps,
  isLastStep,
  primaryProps,
  tooltipProps,
  skipProps,
  className,
}: { className?: string } & TooltipRenderProps) {
  const getLastStepSubmitLabel = () => {
    if (step.locale?.last === 'Last') {
      return 'Concluir';
    }

    return step.locale?.last;
  };

  return (
    <div ref={tooltipProps.ref} role={tooltipProps.role}>
      <Box className={cn(styles.box, className)}>
        <CloseButton onClick={skipProps.onClick} className={styles.closeBtn} />

        {step.content ? <>{step.content}</> : null}

        <Box
          display='flex'
          flexDirection='column'
          justifyContent='space-between'
        >
          {step.title ? <>{step.title}</> : null}

          <Box
            display='flex'
            alignItems='baseline'
            justifyContent={step.showProgress ? 'space-between' : 'end'}
            padding='xs'
            mt={1}
          >
            {step.showProgress && (
              <span className={styles.counter}>{`${
                index + 1
              } de ${size}`}</span>
            )}

            <Box display='flex' mt={1}>
              {index > 0 ? (
                <Button
                  variant='text'
                  className={styles.backBtn}
                  onClick={backProps.onClick}
                >
                  Voltar
                </Button>
              ) : null}

              <Button onClick={primaryProps.onClick}>
                {isLastStep ? getLastStepSubmitLabel() : 'Próximo'}
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </div>
  );
}
